import { Shield, Lock } from 'lucide-react';
import type { FC } from 'react';

interface DividendRate {
  level: number;
  label: string;
  rate: string;
  color: string;
  bg: string;
}

const RATES: DividendRate[] = [
  {
    level: 1,
    label: 'Niveau 1 (filleul direct)',
    rate: '10%',
    color: 'text-blue-600 dark:text-blue-400',
    bg: 'bg-blue-50 dark:bg-blue-900/30',
  },
  {
    level: 2,
    label: 'Niveau 2',
    rate: '3%',
    color: 'text-violet-600 dark:text-violet-400',
    bg: 'bg-violet-50 dark:bg-violet-900/30',
  },
  {
    level: 3,
    label: 'Niveau 3',
    rate: '1%',
    color: 'text-amber-600 dark:text-amber-400',
    bg: 'bg-amber-50 dark:bg-amber-900/30',
  },
];

const DividendRatesCard: FC = () => (
  <div className="fc-card p-5">
    {/* Header */}
    <div className="mb-4 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <Shield className="w-4 h-4 text-blue-600 dark:text-blue-400" />
        <h3 className="text-sm font-semibold text-slate-900 dark:text-white">
          Taux de dividendes
        </h3>
      </div>
      <span className="inline-flex items-center gap-1 rounded-full bg-slate-100 dark:bg-slate-700 px-2.5 py-0.5 text-[10px] font-medium text-slate-500 dark:text-slate-400">
        <Lock className="w-3 h-3" />
        Lecture seule
      </span>
    </div>

    {/* Rates list */}
    <div className="space-y-3">
      {RATES.map((r) => (
        <div
          key={r.level}
          className="flex items-center justify-between rounded-lg border border-slate-100 dark:border-slate-700 px-4 py-3"
        >
          <div className="flex items-center gap-3">
            <div className={`flex h-7 w-7 items-center justify-center rounded-lg text-xs font-bold ${r.bg} ${r.color}`}>
              {r.level}
            </div>
            <span className="text-sm text-slate-700 dark:text-slate-300">{r.label}</span>
          </div>
          <span className={`text-lg font-bold ${r.color}`}>{r.rate}</span>
        </div>
      ))}
    </div>

    <p className="mt-3 text-xs text-slate-400 dark:text-slate-500">
      Les taux sont définis dans la configuration backend (DividendLevel enum).
    </p>
  </div>
);

export default DividendRatesCard;
